import React from "react";
import { Stack } from "@mui/material";
import Timeframe from "./AutoStrategyTimeframe/Timeframe";
import {ButtonStyled} from "../../../_components/ButtonStyled";
import Filters from "../../../components/ui/icons/Filters";

interface Props {
  showTimeframe: (value: boolean) => void;
  timeTerm: "Short" | "Long" | "Mid";
  onChange: (value: "Short" | "Long" | "Mid") => void;
  showAdvanced?: (value: boolean) => void;
}

const AutoStrategyTimeframeSettings = ({ showTimeframe, timeTerm, onChange, showAdvanced }: Props) => {
  return (
    <Stack direction={"column"} spacing={2} sx={{paddingTop: 2}}>
      <Timeframe timeTerm={timeTerm} onChange={onChange} />
      <ButtonStyled
        onClick={() => showTimeframe(true)}
        style={{ display: "flex", justifyContent: "space-between", padding: "8px 16px" }}
        fullWidth={true}
        color={"secondary"}
        variant="contained"
        endIcon={<Filters />}
      >
        Timeframe Settings (optional)
      </ButtonStyled>
      {showAdvanced && (
        <ButtonStyled
          onClick={() => showAdvanced(true)}
          style={{ display: "flex", justifyContent: "space-between", padding: "8px 16px" }}
          fullWidth={true}
          color={"secondary"}
          variant="contained"
          endIcon={<Filters />}
        >
          Advanced settings (optional)
        </ButtonStyled>
      )}
    </Stack>
  );
};

export default AutoStrategyTimeframeSettings;
